import { NavLink } from "react-router-dom";
import { Home, Search, ShoppingBag, Receipt, User } from "lucide-react";
import { useLang } from "@/context/LangContext";
import { useCart } from "@/context/CartContext";
import { useAuth } from "@/context/AuthContext";

export default function BottomNav() {
  const { lang } = useLang();
  const { itemCount } = useCart();
  const { user } = useAuth();

  // Staff (drivers, restaurant owners, admins) don't see the customer bottom nav —
  // they live entirely inside their dedicated dashboards.
  if (user?.is_driver || user?.is_restaurant_owner || user?.is_admin) {
    return null;
  }

  const base = "flex flex-col items-center justify-center gap-0.5 flex-1 h-full text-[10.5px] font-semibold transition-colors";
  const activeCls = "text-[#E05D3A]";
  const inactiveCls = "text-[#6B6B6B]";

  const items = [
    { to: "/", label: lang === "ar" ? "الرئيسية" : "Home", Icon: Home, testId: "bottom-home" },
    { to: "/restaurants", label: lang === "ar" ? "البحث" : "Search", Icon: Search, testId: "bottom-search" },
    { to: "/cart", label: lang === "ar" ? "السلة" : "Cart", Icon: ShoppingBag, testId: "bottom-cart", badge: itemCount },
    { to: "/orders", label: lang === "ar" ? "طلباتي" : "Orders", Icon: Receipt, testId: "bottom-orders" },
    { to: "/profile", label: lang === "ar" ? "حسابي" : "Account", Icon: User, testId: "bottom-profile" },
  ];

  return (
    <nav
      className="md:hidden z-50 flex-shrink-0 bg-white border-t border-[#EAEAEA] flex items-stretch shadow-[0_-6px_24px_rgba(0,0,0,0.06)]"
      style={{
        paddingBottom: "env(safe-area-inset-bottom)",
        minHeight: "calc(64px + env(safe-area-inset-bottom))",
      }}
      data-testid="bottom-nav"
    >
      {items.map(({ to, label, Icon, testId, badge }, idx) => (
        <NavLink
          key={`${to}-${idx}`}
          to={to}
          end={to === "/"}
          className={({ isActive }) => `${base} ${isActive ? activeCls : inactiveCls} h-16`}
          data-testid={testId}
        >
          <div className="relative">
            <Icon className="w-[22px] h-[22px]" strokeWidth={2.2} />
            {badge > 0 && (
              <span className="absolute -top-1.5 -end-2 bg-[#E05D3A] text-white text-[10px] min-w-[16px] h-4 px-1 rounded-full flex items-center justify-center font-bold">
                {badge}
              </span>
            )}
          </div>
          <span className="truncate max-w-[64px]">{label}</span>
        </NavLink>
      ))}
    </nav>
  );
}
